(function () {
    'use strict';

    a3_cabin_reports.factory('ReportsHistoryFactory', ReportsHistoryFactory)

    /* @ngInject */
    function ReportsHistoryFactory($http, apiUrl) {

        /**
         * Fetches the ReportIncidents from API
         * @memberof ReportsHisReportsHistoryFactorytoryCtrl  
         */
        function getReportsHistory(reportId, reportType) {
            return $http.get(apiUrl + '/reports/GetHistoryReport?reportId=' + reportId + '&type=' + reportType, { 'Content-Type': 'application/json' })
                .then(x => { return x });
        }

        var service = {
            getReportsHistory: getReportsHistory,
        }
        return service;
    }

})();   